/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, serializeConvertCustomerToBusinessCommand, type ConvertCustomerToBusinessCommand, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /customers/{customer-id}/business-conversion
 */
export interface BusinessConversionRequestBuilder extends BaseRequestBuilder<BusinessConversionRequestBuilder> {
    /**
     * ConvertCustomerToBusiness
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     post(body: ConvertCustomerToBusinessCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * ConvertCustomerToBusiness
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: ConvertCustomerToBusinessCommand, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const BusinessConversionRequestBuilderUriTemplate = "{+baseurl}/customers/{customer%2Did}/business-conversion";
/**
 * Metadata for all the requests in the request builder.
 */
export const BusinessConversionRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: BusinessConversionRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeConvertCustomerToBusinessCommand,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
